/**
 * Ersatz für window.alert/confirm/prompt: zeigt statt eines Browser-Dialogs
 * ein In-App-Modal (siehe components/DialogHost.js, in App.js gemountet).
 * Läuft unabhängig vom aufrufenden Modal, damit der Dialog auch dann sichtbar
 * bleibt, wenn der Aufrufer sich selbst direkt danach schließt.
 */
let listener = null;

export function registerDialogListener(fn) {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}

function request(config) {
  return new Promise((resolve) => {
    listener({ ...config, resolve });
  });
}

export function showAlert(message, opts = {}) {
  return request({ type: 'alert', message, ...opts });
}

export function showConfirm(message, opts = {}) {
  return request({ type: 'confirm', message, ...opts });
}

export function showPrompt(message, defaultValue = '', opts = {}) {
  return request({ type: 'prompt', message, defaultValue, ...opts });
}
